const navigationLinks = [
  { id: 'home', url: '/', label: 'Головна' },
  { id: 'catalog', url: '/catalog', label: 'Каталог' },
  { id: 'about', url: '/about', label: 'Про нас' },
  { id: 'contacts', url: '/contacts', label: 'Контакти' },
];

export default navigationLinks;
